import { object, string, number, boolean, oneOf, mixed } from 'yup';

const requiredField = document.querySelector('#requiredField')?.value || "Field is required";
const wrongEmail = document.querySelector('#wrongEmail')?.value || "Invalid email address";
const notAllowdNums = document.querySelector('#notAllowdNums')?.value || "Not allowed special characters and numbers";

export const validations = {
    text: {
        required: string()
            .trim()
            .matches(/^[A-Za-z\u0370-\u03FF\u1F00-\u1FFF\s]+$/, { message: notAllowdNums })
            .required(requiredField),

        notRequired: string()
            .trim()
            .matches(/^[A-Za-z\u0370-\u03FF\u1F00-\u1FFF\s]+$/, { message: notAllowdNums })
            .nullable()
    },
    message: {
        required: string().trim().required(requiredField),
        notRequired: string().trim()
    },
    email: string()
        .email(wrongEmail)
        .required(requiredField),

    requiredInput: string().required(requiredField),

    title: string()
        .oneOf(['Mr', 'Ms'], "Invalid title")
        .required(requiredField),

    dayOfBirth: string()
        .matches(/^(0?[1-9]|[12][0-9]|3[01])$/, "Invalid day")
        .required(requiredField),

    monthOfBirth: string()
        .matches(/^(0?[1-9]|1[0-2])$/, "Invalid month")
        .required(requiredField),

    yearOfBirth: string()
        .matches(/^\d{4}$/, "Invalid year")
        .required(requiredField),

    atSlcFrom: string().required(requiredField),

    atSlcUntil: string()
        .required(requiredField)
        .test('is-greater', "Until value must be larger than from", function (value) {
            const fromValue = this.parent.atSlcFrom;
            return fromValue && value > fromValue;
        }),

    checkRequired: boolean().oneOf([true], 'Required'),

    phone: string()
        .matches(/^(?:\+30)?[ ]?(?:\d{3}[ ]?)?\d{3}[ ]?\d{4}$/, 'Check your phone number'),

    file: mixed()
        .required(requiredField)
        .test('fileSize', 'File too large', (value) => {
            return value && value.size <= 2 * 1024 * 1024; // 2MB
        })
        .test('fileType', 'Unsupported file format', (value) => {
            return value && ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(value.type);
        }),
    
    selectField: string()
        .required(requiredField)
        .notOneOf(["", "default"], requiredField)
};
